import React from "react";
import Skeleton, { SkeletonProps } from "./Skeleton";

export type TextSkeletonProps = Omit<
  SkeletonProps,
  "height" | "inline" | "width"
> & {
  lines?: number;
  lineHeight?: SkeletonProps["height"];
  width?: SkeletonProps["width"];
  lastLineWidth?: SkeletonProps["width"];
  gap?: number | string;
};

export default function TextSkeleton({
  lines = 3,
  lineHeight = 14,
  width = "100%",
  lastLineWidth = "72%",
  gap,
  tone = "theme",
  className = "",
  borderRadius = 8,
  style,
}: TextSkeletonProps): JSX.Element {
  const wrapperStyle = gap ? { gap } : undefined;

  return (
    <div className={`domino-text-skeleton ${className}`.trim()} style={wrapperStyle}>
      {Array.from({ length: lines }).map((_, index) => {
        const lineWidth = index === lines - 1 && lines > 1 ? lastLineWidth : width;

        return (
          <Skeleton
            key={`line-${index}`}
            tone={tone}
            width={lineWidth}
            height={lineHeight}
            borderRadius={borderRadius}
            className="domino-text-skeleton__line"
            style={style}
          />
        );
      })}
    </div>
  );
}
